/**
 * Constantes y helpers para la integración con Wacom STU-540 via WebHID.
 * Ref: https://github.com/pabloko/Wacom-STU-WebHID
 */

// ── Identificación del dispositivo ───────────────────────────────────
export const WACOM_VENDOR_ID = 0x056a;

// ── Dimensiones de la STU-540 ────────────────────────────────────────
export const STU540_MAX_X = 10160;       // Rango máximo del digitalizador (eje X)
export const STU540_MAX_Y = 7200;        // Rango máximo del digitalizador (eje Y)
export const STU540_MAX_PRESSURE = 1023; // Presión máxima del lápiz
export const STU540_LCD_W = 800;         // Resolución LCD (ancho)
export const STU540_LCD_H = 480;         // Resolución LCD (alto)

// ── Coordenadas: display pixels → digitizer units ───────────────────
export const dX = (px) => (px / STU540_LCD_W) * STU540_MAX_X;
export const dY = (py) => (py / STU540_LCD_H) * STU540_MAX_Y;

// ── Regiones interactivas en la pantalla LCD ────────────────────────
// Área de firma (recuadro punteado en el LCD)
export const SIGN_BOX = { x1: dX(20), y1: dY(115), x2: dX(780), y2: dY(395) };
// Botones en la parte inferior — hit zone extendida hacia arriba
// para cortar el trazo antes de que llegue al botón visual (evita rayitas).
export const BTN_CONFIRM = { x1: dX(0),   y1: dY(385), x2: dX(399), y2: dY(479) };
export const BTN_CLEAR   = { x1: dX(400), y1: dY(385), x2: dX(799), y2: dY(479) };

/**
 * Verifica si un punto (x, y) está dentro de una región rectangular.
 */
export function inRegion(x, y, r) {
    return x >= r.x1 && x <= r.x2 && y >= r.y1 && y <= r.y2;
}

// ── Report IDs del protocolo STU-540 ────────────────────────────────
export const STU_REPORT = {
    CLEAR_SCREEN:    0x20,   // Limpia el LCD
    INKING_MODE:     0x21,   // Activa/desactiva trazos visibles en LCD
    WRITE_IMG_START: 0x25,   // Inicio transferencia de imagen
    WRITE_IMG_DATA:  0x26,   // Bloque de datos de imagen
    WRITE_IMG_END:   0x27,   // Fin transferencia de imagen
    WRITING_AREA:    0x2A,   // Define el área activa del lápiz en el LCD
    PEN_COLOR_WIDTH: 0x2D,   // Color y grosor del trazo en LCD
    BRIGHTNESS:      0x2B,   // Brillo del backlight
};

// ── Formatos de imagen ──────────────────────────────────────────────
export const IMG_FORMAT_24BGR = 0x04;      // 24-bit BGR (formato nativo STU-540)
export const IMG_FORMAT_1BIT_MONO = 0x00;  // 1-bit monocromo (24x más pequeño)

/**
 * Verifica si un HIDDevice es un dispositivo Wacom.
 */
export function isWacomDevice(d) {
    return (
        d.vendorId === WACOM_VENDOR_ID ||
        (d.productName || '').toLowerCase().includes('wacom') ||
        (d.productName || '').toLowerCase().includes('stu')
    );
}
